export default __webpack_public_path__ + "static/media/Trim The Ingredients.95675b66.png";